var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect3, _rect4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect5, _rect6, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect7, _rect8, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _rect9, _rect10, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _polygon, _path53, _path54, _path55, _rect11, _rect12, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _polygon2, _path65, _ellipse, _path66, _path67, _rect13, _rect14, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _rect15, _rect16, _path80, _path81, _path82, _path83, _path84, _path85, _polygon3, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 450 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4d3b8;}.cls-2{fill:#f2caad;}.cls-3{fill:#f1c9a5;}.cls-4{fill:#3d1c0f;}.cls-5{fill:#ee2a7b;}.cls-6{fill:#733578;}.cls-7{fill:#ddac8c;opacity:0.1;isolation:isolate;}.cls-8{fill:#388ebf;}.cls-9{fill:#2e150b;}.cls-10{fill:#b80308;}.cls-11{fill:#654521;}.cls-12{fill:#ff9800;}.cls-13{fill:#8bc34a;}.cls-14{fill:#85562b;}.cls-15{fill:#976c4b;}.cls-16{fill:#262421;}.cls-17{fill:#fff;}.cls-18{fill:#ca9063;}.cls-19{fill:#056c8e;}.cls-20{fill:#6bbfb0;}.cls-21{fill:#fae43e;}.cls-22{fill:#b3b10a;}.cls-23{fill:#172d39;}.cls-24{fill:#b2a1a1;}.cls-25{fill:#1c4760;}.cls-26{fill:#d1c6c6;}.cls-27{fill:#aeb1b0;}.cls-28{fill:#217808;}.cls-29{fill:#c5c238;}.cls-30{fill:#f26e22;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "round") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.2,252.44c-5.91,7.47.82,36,.82,36s16.38,24.34,25.86,25.09c12-1.61,26.69-5,26.69-5L98,236.27s-13.81,8.09-21.81,16.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77,288.47s-6.71-28.56-.82-36c8-8.11,21.81-16.17,21.81-16.17l15.78,36.14L77,288.47Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.28,
    y: 282.25,
    width: 25.99,
    height: 15.72,
    transform: "matrix(0.92, -0.4, 0.4, 0.92, -109.95, 53.55)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.7,
    y: 282.58,
    width: 25.99,
    height: 7.85,
    transform: "translate(-108.64 52.62) rotate(-23.58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.55,297.69c3.11-2.9,2.93-9,1.26-12.88A14.64,14.64,0,0,0,74.39,281l-16.17,7.06,6.29,14.4,11-4.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.26,283.34C23.39,289.84,18.56,301.82,23,312s16.53,14.82,31.41,8.33,23.32-20.06,18.86-30.27S53.14,276.85,38.26,283.34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.8,281.68c1.09,3.52-1.71,7.44-6.27,8.75s-9.16-.45-10.25-4S35,279,39.55,277.71,48.7,278.16,49.8,281.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.26,283.34C23.39,289.84,18.56,301.82,23,312l50.27-21.95C68.81,279.88,53.14,276.85,38.26,283.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.05,305a22,22,0,0,1-13.63,9.41c-9.24,1.93-12.65-1.87-16.45-.21,5.54-11.22-6-10-5.22-22.31.49-4.45,12.83-12.95,19.18-11.91-14.76-11.5-45.51,7.54-40.94,27.35C24.32,348,83.83,336.8,72.05,305Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.24,308a21.1,21.1,0,0,1,7.48-26,21.19,21.19,0,1,0,16.68,38.2A21.09,21.09,0,0,1,32.24,308Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.55,303.18c1.83-3.89,5.84-15.77,3.45-21.25-3.14-7.19-18.13-14.62-18.13-14.62l.25,3.35a32.22,32.22,0,0,0,1.39,10.2C87.83,284,81.81,294.94,81.82,295a36.6,36.6,0,0,0,6.73,8.22Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.2,252.44c-2,2.53-2.54,7.47-2.4,12.89a23.46,23.46,0,0,1,18,41.23c3.88,3.8,7.89,6.76,11.08,7,12-1.61,26.69-5,26.69-5L98,236.27s-13.81,8.09-21.81,16.17Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.55,373.26c6.82,5.61,33.16-.14,33.16-.14s22.57-14.75,23.35-23.55c-1.37-11.17-4.36-24.83-4.36-24.83l-66.8,28S248.16,365.69,255.55,373.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288.72,373.15s-26.34,5.75-33.16.14c-7.39-7.57-14.65-20.52-14.65-20.52l33.4-14,14.41,34.38Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 282.97,
    y: 364.55,
    width: 14.42,
    height: 24.16,
    transform: "translate(-123.04 141.46) rotate(-22.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 283.25,
    y: 365.95,
    width: 7.21,
    height: 24.16,
    transform: "translate(-123.84 140.29) rotate(-22.74)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M297.17,374.66c-2.63-2.93-8.3-2.86-11.82-1.39a12.8,12.8,0,0,0-3.48,2.18l6.33,15.11L301.5,385l-4.33-10.33Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.62,409c5.83,13.91,16.81,18.61,26.24,14.65s13.79-15.07,8-29c-7.85-18.72-18.22-22-27.66-18S276.09,391.06,283.62,409Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.17,398.27c3.24-1,6.75,1.49,7.78,5.49s-.69,8.07-3.92,9-6.72-1.51-7.78-5.49S278.94,399.23,282.17,398.27Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.26,389.69c2.11,3.58,1.43,7.8-1.54,9.4s-7.08,0-9.19-3.53-1.43-7.8,1.54-9.4S318.15,386.11,320.26,389.69Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.62,409c5.83,13.91,16.81,18.61,26.24,14.65l-19.7-47C280.72,380.62,276.09,391.06,283.62,409Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M255.55,373.26c4.39,3.6,16.73,2.53,25.08,1.3a8,8,0,0,1,14.77-6.19c6.73-5.09,16.14-13.14,16.65-18.8-1.37-11.17-4.36-24.83-4.36-24.83l-66.8,28S248.16,365.69,255.55,373.26Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.69,430.44c4,2.82,16.79.35,28.25-6a.42.42,0,0,1,0-.2c13.07-9.73,6.86-22-.26-27-.94-2-2-4.23-3.33-6.92,0,0-.4,4.89,1.76,13.06,0,.44-.09.9-.15,1.36-9.69-3.43-18.3-.87-25.91,11.33-2.93-6.23-6.43-9.41-9.83-11.41.56,2,1.07,3.84,1.55,5.51-1,8.32,4.24,17.68,8,20.29Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.1,141.84c-8.79.86-23.35,23.54-23.35,23.54s-5.52,26.39.14,33.16C87.76,205.48,99.54,213,99.54,213L127,146S112.68,142,102.1,141.84Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.72,165.38s14.56-22.69,23.35-23.54c10.57.13,24.87,4.15,24.87,4.15L113.22,179.5l-34.5-14.12Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.02,
    y: 151.87,
    width: 14.42,
    height: 24.16,
    transform: "translate(-105 171.47) rotate(-67.74)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 72.99,
    y: 148.53,
    width: 7.21,
    height: 24.16,
    transform: "translate(-101.06 170.66) rotate(-67.74)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.68,170.29c3.93.21,7.89-3.84,9.34-7.38a12.8,12.8,0,0,0,.92-4l-15.16-6.2L61.32,166l10.36,4.24Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57,136.41c-14-5.71-25-1.27-28.92,8.2S29,165,42.93,170.72c18.79,7.69,28.42,2.66,32.3-6.81S75,143.78,57,136.41Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.59,143c-1.61,3-5.83,3.72-9.39,1.62s-5.22-6.19-3.61-9.16,5.82-3.69,9.39-1.62S67.2,140,65.59,143Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.72,176c-4-1-6.52-4.5-5.56-7.73s5-5,9-4,6.52,4.5,5.56,7.73S48.75,177,44.72,176Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57,136.41c-14-5.71-25-1.27-28.92,8.2l47.17,19.31C79.1,154.44,75,143.78,57,136.41Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.1,141.84c-5.65.56-13.62,10-18.66,16.81a8,8,0,0,1-6.07,14.82c-1.16,8.36-2.12,20.71,1.52,25.07C87.76,205.48,99.54,213,99.54,213L127,146S112.68,142,102.1,141.84Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.82,126.26c-4.84.86-12.12,11.63-15.73,24.22a.42.42,0,0,1,.17.11C18.9,166.71,32,171,40.56,169.5c2.07.74,4.42,1.56,7.25,2.54,0,0-3.17-3.74-10.48-8-.29-.34-.57-.7-.86-1.07,9.28-4.42,13.56-12.33,10.31-26.33,6.48,2.33,11.2,2.11,15,1.12-1.84-1-3.47-2-5-2.8-5.16-6.6-15.5-9.5-20-8.72Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M379.75,294.19c4.56-7.31,1.36,5.17,2,5.79a83,83,0,0,0,9.3,7.6c-.24,1.16,1,5.42.76,6.57-3.95-1.42-8.43-8.48-9.66-11.06-1-2-2.59-6.92-2.4-8.9Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M381.34,280.86l-9.56-8.66c0-.48-.08-1-.13-1.41,2.88.46,6.22-1.15,8.45,2.11a2.55,2.55,0,0,0,2.22.74c4.37-1.54,6.13,2.9,9.36,3.92.11,0,0,.65,0,1-2.23,1.42-4.46,2.85-6.69,4.25-1.48-.14-2.41-1.36-3.69-1.94Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.61,310.66c8.9-1.3,22.64-25.12,22.64-25.12s4.3-27.14-1.79-33.77c-9.39-6.61-21.72-13.75-21.72-13.75l-24.65,69.66s14.77,3.35,25.54,3Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.24,285.53s-13.73,23.8-22.64,25.12c-10.76.37-25.54-3-25.54-3l12.33-34.83,35.85,12.69Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 375.74,
    y: 274.28,
    width: 14.72,
    height: 24.63,
    transform: "translate(-14.88 552.13) rotate(-70.51)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 378.2,
    y: 277.73,
    width: 7.36,
    height: 24.63,
    transform: "translate(-18.95 553.28) rotate(-70.51)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.43,280c-4,0-7.87,4.29-9.18,8a13.19,13.19,0,0,0-.75,4.11l15.76,5.58,4.91-13.88L386.43,280Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.83,314c14.51,5.13,25.57.07,29.06-9.79s-1.92-20.75-16.43-25.89-29.09-1.32-32.58,8.54S385.33,308.82,399.83,314Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.74,307.69c1.52-3.11,6-4,10-1.94s6.05,6.2,4.54,9.3-6,4-10,1.94S389.23,310.78,390.74,307.69Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.15,271.56c4.41,1,7.33,4.44,6.54,7.79s-5,5.31-9.38,4.37-7.33-4.44-6.54-7.79S401.76,270.61,406.15,271.56Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.83,314c14.51,5.13,25.57.07,29.06-9.79l-49-17.35C376.39,296.68,385.33,308.82,399.83,314Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M377.7,268.07c-3.78,1.46-14.21,7-16.08,12.29-2.46,6.94,3.14,21.64,3.14,21.64l2-2.46a29.26,29.26,0,0,0,5.61-7.87c-6.53-10.07,4.69-13.67,4.69-13.67A32.54,32.54,0,0,0,377.7,268.07Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M353.61,310.66c3-.45,6.58-3.46,10-7.25a21.88,21.88,0,0,1,14-39.69c-.24-5.1-1.13-9.67-3.18-11.9-9.39-6.61-21.72-13.75-21.72-13.75l-24.64,69.61s14.77,3.35,25.54,3Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M426.23,305.78c2.73-.37,5.94-3,8.6-2.09-3,8.66-10.48,16-19.21,15.58-1.17-.05-2.36-.08-3.56-.12-3.23-.83-8.1,1.66-10.86-1.22a6.24,6.24,0,0,1,4.94-4.21c2.81-.39,5.6-1.06,8.41-1.57a19.9,19.9,0,0,0,11.67-6.38Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M426.12,306.08c4.84-.62,6.74,1.63,8.7-2.39.86-1.74.65-5.9.51-7.77a26.11,26.11,0,0,0-6.28-15.12,36.15,36.15,0,0,0-16.75-10.89c-6.95-2.09-13.83-.39-20.61-1.55-5.07-.87-11.46-5.56-16.3-5.77-1.23,0-2.77.75-3.79.68a2.5,2.5,0,0,1-1.08,1.39,8.61,8.61,0,0,0-3.37-1.88c-6.08-.69-13-1.79-18.95-1.38-5,.34-3.95.5-5.83,5.82,7.14-1.88,15.66,2.16,22.62,3,7.19.92,13.45,4.08,20.51,6.33,3.91,1.26-.58,1.37,5,1.34,2.76,0,6.65-1.05,9.29-1.65,5.7-1.32,4.61-1.68,9.28,1.63,5.15,3.67,6.51,4.83,7.56,11.29,1.14,6.75.72,15.22,9.47,16.88,2.7-.36-2.46-.46,0,0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M375.11,202.06c6.24-6.83,1.65-34.7,1.65-34.7S362.52,143,353.38,141.67c-11.76.84-26.21,3.2-26.21,3.2l25.68,71.37S366.78,209.35,375.11,202.06Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.76,167.36s4.57,27.87-1.65,34.7c-8.32,7.32-22.24,14.24-22.24,14.24L340,180.61l36.74-13.22Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 367.84,
    y: 158.46,
    width: 25.3,
    height: 15.12,
    transform: "translate(-33.74 138.63) rotate(-19.79)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 369.12,
    y: 165.8,
    width: 25.3,
    height: 7.56,
    transform: "translate(-34.87 139.27) rotate(-19.79)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M378.82,158.59c-3.21,2.59-3.46,8.51-2.09,12.31a13.61,13.61,0,0,0,2.09,3.75L395,168.84l-5.12-14.23Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414,174.62c14.86-5.35,20.37-16.58,16.73-26.68s-15-15.25-29.89-9.9c-20,7.2-24,17.88-20.35,28S394.84,181.51,414,174.62Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M402.06,173.8c-.84-3.44,1.93-7,6.18-7.87s8.39,1.14,9.24,4.6-1.93,7-6.19,7.85-8.38-1.12-9.23-4.58Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M396.4,137c3.86-2,8.23-1.08,9.77,2.11s-.35,7.42-4.19,9.44-8.24,1.06-9.78-2.13.36-7.4,4.2-9.41Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414,174.62c14.86-5.35,20.37-16.58,16.73-26.68L380.49,166C384.14,176.11,394.84,181.51,414,174.62Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M375.11,202.06c3.63-4,3.6-15.14,2.92-23.72l-15.18-5.94,7.92-14.25c-4.95-7-12-15.67-17.37-16.42-11.76.84-26.21,3.2-26.21,3.2l25.68,71.37S366.78,209.35,375.11,202.06Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M394,143.17S412,136,414,148.49c-4.46,1.45.17,7.92.17,7.92s8.1,7.77,17.84,2.92c2.47-17-10.35-24.94-15.39-26S399.18,135.27,394,143.17Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M427.27,159c-6.32-1.78-8.84,11.24-20.93,15.59,7.75,2,29.56-.69,25.69-15.26a32.63,32.63,0,0,0-4.76-.33Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M365.11,186.3l4.5-10.56-6.77-3.4,15.35,4.18a5.12,5.12,0,0,1-2,5c-4.67,2.05-11.09,4.76-11.09,4.76Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "339.01 177.79 340.01 180.59 362.86 172.37 364.5 168.62 339.01 177.79"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M355.71,160.17l10.2,5.27-3,6.93,9.16-13a5.12,5.12,0,0,0-4.73-2.6c-4.9,1.42-11.58,3.4-11.58,3.4Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.2,347.79c.42,9.24,23.37,25.7,23.37,25.7s27.32,7.18,34.7,1.64c7.73-8.91,16.27-20.8,16.27-20.8L146.91,322S141.93,336.75,141.2,347.79Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.57,373.49S141.63,357,141.2,347.79c.71-11.06,5.66-25.8,5.66-25.8l34.31,16.15-16.63,35.33Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 150.23,
    y: 369.52,
    width: 25.3,
    height: 15.12,
    transform: "translate(-247.66 363.83) rotate(-64.79)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 146.81,
    y: 371.69,
    width: 25.3,
    height: 7.56,
    transform: "translate(-248.17 359.81) rotate(-64.79)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M169.31,381.16c.44-4.1-3.57-8.47-7.23-10.19a13.61,13.61,0,0,0-4.14-1.17l-7.31,15.53,13.68,6.44Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.1,394.7c-6.73,14.29-2.67,26.13,7,30.7s21.41.15,28.14-14.14c9.06-19.23,4.31-29.6-5.4-34.17S141.77,376.27,133.1,394.7Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.12,386.84c3,1.84,3.55,6.28,1.2,9.94s-6.74,5.13-9.79,3.28-3.55-6.28-1.17-9.93,6.72-5.14,9.77-3.29Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.16,408.86c-1.3,4.16-5.06,6.58-8.4,5.42s-5-5.5-3.71-9.63,5.08-6.57,8.42-5.41,5,5.49,3.69,9.62Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.1,394.7c-6.73,14.29-2.67,26.13,7,30.7l22.74-48.31C153.16,372.53,141.77,376.27,133.1,394.7Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M141.2,347.79c.25,5.39,8.16,13.25,14.71,18.84l14.94-6.54,4.48,15.68c8.48,1.48,19.58,2.57,23.89-.67,7.73-8.91,16.27-20.8,16.27-20.8L146.86,322S141.93,336.75,141.2,347.79Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M169.51,402.76s-7.66,17.85-18,10.44c2.13-4.18-5.72-5.48-5.72-5.48s-11.22.23-14.67,10.55c10.28,13.78,25,10.31,29.3,7.53S171.41,412,169.51,402.76Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M134.78,415.15c5.73-3.2-1.7-14.2,3.78-25.83-6.9,4.06-20.41,21.39-7.37,29a32.63,32.63,0,0,0,3.6-3.13Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M159.41,351.87l4.28,10.65,7.19-2.38L157.07,368a5.12,5.12,0,0,1-2.14-4.95c1.85-4.75,4.48-11.21,4.48-11.21Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "183.89 339.43 181.2 338.16 170.86 360.13 172.34 363.94 183.89 339.43"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M184.54,363.7l-10.93,3.48-2.75-7.06,2.71,15.67a5.12,5.12,0,0,0,5.18-1.51c2.46-4.47,5.79-10.6,5.79-10.6Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 304.07,
    cy: 49.91,
    rx: 27.23,
    ry: 27.03,
    transform: "translate(140.64 311.14) rotate(-67.29)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.16,107.77C313.35,98.69,290,83.46,290,83.46s-27.21-5.92-34.25-.12c-7.21,9.09-15.12,21.2-15.12,21.2l69,28.88S313.95,118.67,314.16,107.77Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290,83.46s23.31,15.23,24.12,24.31c-.23,10.94-4.49,25.65-4.49,25.65L275.16,119,290,83.46Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 279.09,
    y: 72.38,
    width: 24.96,
    height: 14.91,
    transform: "translate(105.36 317.98) rotate(-67.29)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 282.52,
    y: 77.53,
    width: 24.96,
    height: 7.47,
    transform: "translate(106.14 322.02) rotate(-67.29)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M285,76.11c-.24,4.08,3.9,8.18,7.57,9.72a13.49,13.49,0,0,0,4.11,1l6.54-15.62-13.75-5.75Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.16,61.21c6-14.37,1.52-25.86-8.24-29.95s-21.09.78-27.11,15.15-3,29.35,6.78,33.43S314.14,75.58,320.16,61.21Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.24,69.61c-3.05-1.67-3.79-6-1.66-9.62s6.36-5.22,9.47-3.58,3.79,6,1.66,9.62S315.3,71.28,312.24,69.61Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.41,48.79c1.06-4.08,4.65-6.58,8-5.58s5.17,5.14,4.1,9.26-4.65,6.58-8,5.56-5.12-5.16-4.06-9.24Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.16,61.21c6-14.37,1.52-25.86-8.24-29.95L291.59,79.84C301.34,83.92,314.14,75.58,320.16,61.21Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.75,27.27C304.19,22.86,289.7,30.62,285,41.77l0,.11,4.36,1.83,6.94-5.88-5.7,6.41,5,1.05L299,39l-2.78,6.64,3.6,1.08,4.81-6-2.74,6.65,4.75,1.82,2.49-5.94-.66,6.53,5.79,2.34,2.53-4.2.77,7.22,5.71,2.73,0-.11c4.63-11.07,2-26-8.55-30.42Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.12,31.72s-.46-15-11.43-11.81-5.38,29.33-17.35,22.82c2.47,6.55,9.6,6.52,14.44-3.61s8-4.49,8-4.49"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.77,52.13s6.23-1.7,2.41,8.85,1.16,15.65,7.56,12.82c-13-3.95,9.53-18.33,4.07-28.37s-16.43.15-16.43.15"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M309.78,34.63c9.13,3.82,14.51,12.28,13.15,19.85A13.35,13.35,0,0,0,324.31,52c3.42-8.18-2.09-18.28-12.35-22.58s-21.33-1.13-24.75,7a13.35,13.35,0,0,0-.8,2.73C290.89,32.93,300.65,30.81,309.78,34.63Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M314.16,107.77c-.2-2.41-2-5.23-4.5-8.09-5.33-1.15-13.79-4-23.11-7.9s-17.28-7.92-21.85-10.91c-3.8.22-7.06.92-8.92,2.47-7.21,9.09-15.12,21.2-15.12,21.2l69,28.88S313.95,118.67,314.16,107.77Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.55,78.74c-7.5-5.9-35.83.94-35.83.94s-24,16.48-24.66,26c1.76,12,5.3,26.75,5.3,26.75l71.53-31.87s-8.19-13.81-16.34-21.83Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.72,79.67s28.32-6.81,35.83-.94c8.14,8,16.34,21.83,16.34,21.83L181.12,116.5l-16.4-36.82Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 155.26,
    y: 62.88,
    width: 15.6,
    height: 26.12,
    transform: "translate(-16.79 72.93) rotate(-24.01)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 162.72,
    y: 61.3,
    width: 7.79,
    height: 26.12,
    transform: "translate(-15.84 74.23) rotate(-24.01)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M155.54,78.23c2.92,3.11,9,2.9,12.82,1.22a13.6,13.6,0,0,0,3.7-2.44l-7.21-16.18L150.6,67.18l4.93,11.06Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.35,40.8c-6.64-14.9-18.61-19.72-28.73-15.21s-14.54,16.63-7.91,31.53c8.93,20,20.21,23.31,30.33,18.8S177.91,60,169.35,40.8Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.18,52.37c-3.47,1.13-7.3-1.45-8.56-5.76s.54-8.73,4-9.87,7.3,1.45,8.56,5.76S174.65,51.24,171.18,52.37Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.7,61.28c-2.37-3.82-1.72-8.39,1.44-10.21s7.67-.21,10,3.6,1.72,8.39-1.44,10.21-7.67.21-10-3.6Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.35,40.8c-6.64-14.9-18.61-19.72-28.73-15.21L163,75.92c10.12-4.51,14.86-15.92,6.31-35.12Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M200.55,78.74c-4.38-3.44-15.87-2.55-24.65-1.21l5.22,39L155.65,86.54c-6.87,5.64-15.21,13.58-15.59,19.14,1.76,12,5.3,26.75,5.3,26.75l71.53-31.87s-8.19-13.81-16.34-21.83Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "155.32 86.71 181.12 116.5 175.93 77.53 170.93 93.62 155.32 86.71"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M178.94,115.52l-20.23-9a.53.53,0,0,1-.16-.87l3.33-3.31a.54.54,0,0,0-.13-.86l-13.52-7.27a.54.54,0,0,1-.13-.86c.69-.68,1.91-1.91,2.57-2.54A43.15,43.15,0,0,1,155,87a.53.53,0,0,1,.72.07l23.78,27.61a.53.53,0,0,1-.61.83Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M159,101.75,163.52,91a.06.06,0,0,1,.07,0l7,2.47c.05,0,.1-.06,0-.08l-12.29-8.95s-.05,0-.06,0l-3.84,3s0,0,0,.07c1.69,4.59,4.1,13,4.45,14.19a.06.06,0,0,0,.11,0Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M169.67,36.65s-4.36-1-2.54,6.86c-2.58-7-7.09-16.24-13.37-15.48-.61,6.89-11.15,15.83-20,17.42-3.86,2,.07,2,2.36,14.22-2.11-5.07-3.48-8.14-6.24-5.73-5.55-10.16-5.73-26.08,9.83-33s25.42,1.29,30,15.72Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M181.65,114.22l6.82-21.08a.53.53,0,0,0-.54-.7l-4.69.26a.54.54,0,0,1-.55-.67l3.63-14.91a.54.54,0,0,0-.55-.67c-1,.06-2.7.14-3.61.21a43.15,43.15,0,0,0-5.73.72A.53.53,0,0,0,176,78l4.62,36.15a.52.52,0,0,0,1,.11Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M184.77,90.17l-11-3.77a.06.06,0,0,0-.07,0l-2.82,6.83c0,.05-.11,0-.09,0l1.57-15.12s0-.05,0,0l4.81-.83s0,0,.06,0c2.28,4.33,6.91,11.74,7.57,12.79,0,.05,0,.11-.06.09Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M149,219.38a78.32,78.32,0,0,1,19-45.76L126,131.69a137.34,137.34,0,0,0-36.32,87.69Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M233.15,87.32v59.3a78.32,78.32,0,0,1,45.76,19l41.93-41.93A137.33,137.33,0,0,0,233.15,87.32Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M168,276.53a78.33,78.33,0,0,1-19-45.76H89.71A137.34,137.34,0,0,0,126,318.45Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M176,165.57a78.33,78.33,0,0,1,45.76-19V87.32a137.34,137.34,0,0,0-87.69,36.32Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M221.77,303.53a78.33,78.33,0,0,1-45.76-19L134.08,326.5a137.34,137.34,0,0,0,87.69,36.32Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M278.91,284.57a78.34,78.34,0,0,1-45.76,19v59.3a137.34,137.34,0,0,0,87.69-36.32Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M287,173.62a78.32,78.32,0,0,1,19,45.76h59.3a137.34,137.34,0,0,0-36.32-87.69Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M305.91,230.76a78.32,78.32,0,0,1-19,45.76l41.93,41.93a137.34,137.34,0,0,0,36.32-87.69Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 226.87,
    cy: 228.35,
    r: 60.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.ee9dcbf25a2bf3467b42a78e477a69f8.svg";
export { ForwardRef as ReactComponent };